/**
 * useAppContext — convenience hook to consume AppContext.
 *
 * Extracted into its own file so that react-refresh/only-export-components
 * is satisfied: AppContext.tsx exports only the AppProvider component,
 * while this file exports only the hook.
 *
 * Usage:
 *   import { useAppContext } from '../../app/provider/useAppContext';
 *   const [ctx, setCtx] = useAppContext();
 */
import { useContext } from 'react';

import type { AppContextValue } from '../../shared/types';

import AppContext from './AppContext';

/**
 * Convenience hook to consume AppContext.
 * Throws if called outside <AppProvider>.
 */
export function useAppContext(): AppContextValue {
  const value = useContext(AppContext);
  if (value === undefined) {
    throw new Error('useAppContext must be used within an <AppProvider>');
  }
  return value;
}
